import assetsReducer from './assetsSlice'

export default assetsReducer
